import HttpClient from "./HttpClient";

export const MintgramURL = new HttpClient(process.env.REACT_APP_API_URL as string);
export const MVPrefabricURL = new HttpClient("https://mvp-api.refabric.com/");
